import React, { useEffect } from "react";
import { SERVER_URL } from "../../config/serverUrl";

// Full-screen frame for the Admin Design Studio — the design-choice wizard
// minime-web serves at /design-studio. Framing it here puts the wizard on the
// app's own domain (a familiar per-environment URL to hand out), while the
// wizard itself stays a single canonical copy that ships with the backend;
// its saves go to Dropbox through the same backend that serves it, so the
// iframe's requests are same-origin and CORS never enters the picture.
const serverUrl = SERVER_URL;

const DesignStudioFrame = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "סטודיו העיצוב של מינימי";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  if (!serverUrl) {
    return (
      <div style={{ direction: "rtl", padding: 40, fontFamily: "Heebo, sans-serif" }}>
        סטודיו העיצוב לא זמין — כתובת השרת אינה מוגדרת בסביבה הזאת.
      </div>
    );
  }

  return (
    <iframe
      src={`${serverUrl}/design-studio`}
      title="סטודיו העיצוב של מינימי"
      allow="clipboard-write"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
        background: "#f4f3f0",
      }}
    />
  );
};

export default DesignStudioFrame;
